import apiUrl from '../../../constants'
import axios from 'axios'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import CryptoJS from 'crypto-js'
import DatePicker from 'vue2-datepicker'
import rtoApis from '../../../views/components/rtogrn/rtogrn'
import Loader from './../shared/loader'
import Printd from 'printd'
import {
	Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading'
import {
	WebCam
} from "vue-web-cam"
import common_helper from '../../../common_helper'
import vSelect from 'vue-select'


export default {
	name: 'grc',
	components: {
		WebCam,
		Multiselect,
		DatePicker,
		Loader,
		VueElementLoading,
		vSelect
		},
	props: ['selectedRow', 'filterData', 'searchflag'],
	data() {
		return {
			isexpirycutoff: false,
			ThreshholdExp: '',
			cut_off_Expirydate: '',
			productUploadLabelUrlsave: '',
			onloadingFalse:false,
			showaddimage: true,
			showfileselect: false,
			showcameraselect: false,
			Skunameerr: '',
			Skuiderr: '',
			Size: '',
			getPono: '',
			cameraImage: null,
			isToggled: false,
			outsideproductFoundinNop: false,
			uploadPictures: false,
			isLoading7: false,
			isLoading3: false,
			imageCaptured: false,
			productUploadImage1Url: '',
			productUploadImage2Url: '',
			productUploadImage3Url: '',
			createdbyEmail: '',
			productUploadLabelUrl: '',
			Skuid: '',
			brand: '',
			Skuname: '',
			imageUrl: '',
			color: '',
			mrp: '',
			fileSection: '',
			productUploadLabelUpload: '',
			Recievedqty: '',
			viewImage: false,
			outsideproductshow: false,
			outsideproduct: false,
			quantity: '',
			Merchantid: '',
			showmodal: false,
			showicon: false,
			smartPOCheck: '',
			rejectOptions: [],
			holdOptions: [],
			todayDate: '',
			flag: false,
			size: '30px',
			isFoundTotalCheckqty: false,
			rejectedReasonList: [],
			holdReasonList: [],
			selected: '',
			DRerrors: '',
			IDerrors: '',
			ShelflifeErrors: '',
			MRPerrors: '',
			MRPsuccess: '',
			isError: '',
			checked: false,
			selected: '',
			searchProductFlt: '',
			productSearchModal: false,
			expiryDetailsModal: false,
			invoicePQuantity: 0,
			checkQtyerrors: '',
			acceptQtyerrors: '',
			rejectQtyerrors: '',
			shortQtyerrors: '',
			holdQtyerrors: '',
			rejectReasonErrors: '',
			holdReasonErrors: '',
			expairyErrors: '',
			validateAllErrors: '',
			validateAllErrorsFlag: false,
			shelflifeuomErrors: '',
			searchProductFltError: '',
			expiryDtlErrors: '',
			rejectReason: [],
			holdReason: [],
			productDescription: '',
			selectPoNoList: [],
			checkProductMrp: 0,
			isfoundDR: false,
			isnotfoundDR: false,
			isFoundProductInPO: false,
			isNotFoundProductInPO: false,
			isProductNotInPO: false,
			cameraSection: false,
			isfoundMRP: false,
			isnotfoundMRP: false,
			isfoundReject: false,
			shelfLifeCheck: false,
			isExpiry: true,
			lotControlCheck: false,
			productidcheck: true,
			shelfandDurationcheck: false,
			expControlCheck: false,
			shelflifeuomflag: false,
			isExpiryCol: false,
			isshelflife: false,
			totalRemainForThis: 0,
			totalCheckedQty: 0,
			loginUserEmail: '',
			isMrpTrue: false,
			addGRC: {
				eancode:'',
				productname:'',
				lotno: '',
				DRNo: '',
				productid: '',
				productdesc: '',
				MRP: '',
				productqty: 0,
				checkedqty: 0,
				acceptedqty: 0,
				mfgdate: '',
				shelfLife: '',
				expdate: '',
				rejectedqty: 0,
				holdqty: 0,
				productImage: '',
				ifHold: '',
				pono: '',
				inwardid: '',
				invoiceno: '',
				pickPoNo: '',
				warehouseid: 0,
				lotControl: '',
				productlinenumber: '',
				invoiceQty: '',
				merchantid: 0,
				shortqty:0
			},
			loading: false,
			loadingText: '<i class="fa fa-spinner fa-spin fa-2x" style="color:#1985ac"></i>',
			rightIcon: '<i class="fa fa-check" style="font-size:25px;color:green" v-if="isFoundProductInPO"></i>',
			wrongIcon: '<i class="fa fa-close" style="font-size:25px;color:red" v-if="isNotFoundProductInPO"></i>',
			productCheckIcon: '',
			clientid: '',
			mrpOptions: [{
				value: '',
				text: this.$t('stockTransfer.mrpError')
			}],
			isFoundInvoiceQty: false,
			grcReceivedQty: 0,
			grcRejectedQty: 0,
			grcHoldQty: 0,
			grcCheckedQty: 0,
			grcShortQty:0,
			podetailsmodal: false,
			podata: [],
			poloopdata: [],
			clientdata: [],
			supplierdata: [],
			productColor: '',
			merchantname: '',
			productImage: '',
			productSize: '',
			productId: '',
			productData: false,
			outsideproductdetails: {
				skuid: '',
				skuname: '',
				DrRecievedqty: '',
				brand: '',
				color: '',
				size: '',
				qty: ''
			},
			notinpo: {
				mrp: 0,
				qty: 0,
			},
			notinpoError: {
				mrp: false,
				qty: false,
			},
			isLoading: false,
			userwarehouseid: '',
			potolerance: {},
			maxpoqty: 0,
			user_type: '',
			showshelflifeflag: false,
			ShelfLifeuom1: '',
			ShelfLife: '',
			shelflifecheckfordate: true,
			imagetype:["Label image","Product Image 1","Product Image 2","Product Image 3"],
			showimagetype:'',
			productUploadUrl:'',
			StoreimageUrls:[],
			currentimageno:0,
			totalImageCount:4,
			cameralist: '',
			cameras: [],
			selectFirstDevice: true,
			deviceId: null,
			playsinline: false,
			notcheckbtn: false,
			autoplay: true,
			screenshotFormat: "image/jpeg",
			crossdockmodal:false,
			crossdockqty:0,
			crossdockdata:[],
			checkCrossDock:'',
			crossdockquantity:0,
			acceptedqty:0,
			crossdockmsg : '',
			shortReason: '',
		}
	},
	model: {
		totalpricewithtax: 0,
		sgst: 0,
		cgst: 0,
		igst: 0,
		totalpricewithouttaxes: 0,
		smartPOCheck: '',
		hideAcceptedBarcode:false,
		hideRejectedBarcode:false
	},
	computed: {
		isComplete() {
			var isComplete = this.addGRC.DRNo && this.addGRC.productid && this.addGRC.MRP && this.addGRC.checkedqty && this.addGRC.acceptedqty && this.addGRC.shortqty;

			isComplete = this.checkRejectHoldQty();
			return isComplete;
		},

		isEnblRejectReason() {
			if (this.addGRC.rejectedqty > 0) {
				return true;
			} else {
				return false;
			}
		},
		isEnblHoldReason() {
			if (this.addGRC.holdqty > 0) {
				return true;
			} else {
				return false;
			}
		},
		istotalquantitymatched() {
			if (this.saveGRCdata.totalqty == (Number(this.saveGRCdata.acceptedqty) + Number((this.saveGRCdata.rejectedqty)))) {
				return true;
			} else {
				return false;
			}
		},
		islotcontrol() {
			if (this.lineitemdata.islotcontrol == 1) {
				return true;
			} else {
				return false;
			}
		},
		isqtymatched() {
			if (this.checkallqtymatched()) {
				return true;
			} else {
				return false;
			}
		},
		totalpricewithtax: function() {
			return this.poloopdata.reduce(function(totalpricewithtax, item) {
				return totalpricewithtax + parseFloat(item.totalpricewithtax);
			}, 0);
		},
		sgst: function() {
			return this.poloopdata.reduce(function(sgst, item) {
				return sgst + parseFloat(item.totalpricewithouttaxes) * parseFloat(item.sgstratepercent) / 100;
			}, 0);
		},
		cgst: function() {
			return this.poloopdata.reduce(function(cgst, item) {
				return cgst + parseFloat(item.totalpricewithouttaxes) * parseFloat(item.cgstratepercent) / 100;
			}, 0);
		},
		igst: function() {
			return this.poloopdata.reduce(function(igst, item) {
				return igst + parseFloat(item.totalpricewithouttaxes) * parseFloat(item.igstratepercent) / 100;
			}, 0);
		},
		totalpricewithouttaxes: function() {
			return this.poloopdata.reduce(function(totalpricewithouttaxes, item) {
				return totalpricewithouttaxes + parseFloat(item.totalpricewithouttaxes);
			}, 0);
		}
	},
	filters: {
		moment: function(date) {
			return moment(date).format('YYYY-MM-DD');
		}
	},
	mounted() {
		this.todayDate = moment().format('DD/MM/YYYY');
		this.showSearchDR('');
		let userdetail = this.getLocalUserData();
		this.user_type = userdetail.roleid;
		this.login = userdetail.utype;
		var userToken = window.localStorage.getItem('userToken')
		this.token = userToken.replace(/"/g, '')
		this.createdbyEmail = userdetail.email;
		this.showimagetype=this.imagetype[this.currentimageno]

		if (userdetail && this.login == 'warehouse_user') {
			this.userwarehouseid = userdetail.warehouseid;
		} else {
			this.$alertify.error(this.$t('grcList.grcAuthErr'));
			this.productidcheck = false

			this.userwarehouseid = null;

		}

	},
	created() {
		this.$validator.extend('currentCheckQty', {
			getMessage: field => this.$t('editedjson.checkQtyError'),
			validate: value => {
				return true
			}
		});
		this.$validator.extend('totalAcceptQty', {
			getMessage: field => this.$t('editedjson.acceptedQtyError'),
			validate: value => {
				if (value) {
					if (parseFloat(value) > parseFloat(this.addGRC.checkedqty)) {
						this.hideAcceptedBarcode = true
						return false;
					} else {
						if(!this.checkQtyerrors){
							this.hideAcceptedBarcode = false
						}
						return true;
					}
				} else {
					this.hideAcceptedBarcode = true
					return false;
				}
			}
		});
	},
	methods: {
		isImageuploaded(){
			var isimageUpload=[]
			  isimageUpload = this.StoreimageUrls.filter(img => img.url != "");
			  if(isimageUpload.length>0){
                 return true
			  }else{
				  return false
			  }
		},
		checkonload(){
			this.isLoading=false
		},
		cameraSelected() {
			this.$refs.cameraImage.changeCamera(this.cameralist)
		},
		camerass(camlist) {
			this.cameras = camlist
		},

		showList() {
			this.$emit("goBackToParent")
		},
		getLocalUserData() {
			var userdetailEncrypt = window.localStorage.getItem('userdetail')
			var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
			var plaintext = bytes.toString(CryptoJS.enc.Utf8);
			var userdetail = JSON.parse(plaintext);
			return userdetail;
		},
		checkexpirycutoff(expirydate) {
			var expairyDate = moment(expirydate).format('YYYY-MM-DD')
			if (expairyDate != null && this.cut_off_Expirydate != null && expairyDate <= this.cut_off_Expirydate) {
				this.$alertify.error(this.$t('grcList.productExpiryErr'), this.ThreshholdExp)
				this.validateQty('acceptqty')
				this.addGRC.acceptedqty = 0;
				this.isexpirycutoff = true
				document.getElementById('acceptedqty').value = ''
				document.getElementById('acceptedqty').disabled = true
				if (this.addGRC.checkedqty != null || this.addGRC.checkedqty != "") {
					this.showRejectedQuantity(true);
				}
				return false
			} else {
				this.isexpirycutoff = false
				document.getElementById('acceptedqty').disabled = false
				this.isfoundReject = true;
			}
		},
		thresholdValueexp(ThreshholdExp) {
			var shelfLifes = ThreshholdExp.split(' ');
			if (shelfLifes[0].trim() != '' && shelfLifes[1].trim() != '') {
				var shelfLifeNo = shelfLifes[0].trim();

				if (shelfLifeNo == null || shelfLifeNo == "null")
					shelfLifeNo = 0;
				var shelfLifeCel = shelfLifes[1].trim();
				var start = new Date();
				var mfgYear = start.getFullYear();
				var mfgMonth = start.getMonth();
				var mfgDay = start.getDate();

				switch (shelfLifeCel) {
					case 'year':
						var fullExpDate = new Date(mfgYear + parseInt(shelfLifeNo), mfgMonth, mfgDay); //
						break;

					case 'month':
						var fullExpDate = new Date(mfgYear, mfgMonth + parseInt(shelfLifeNo), mfgDay);
						break;

					case 'days':
						var fullExpDate = new Date(mfgYear, mfgMonth, mfgDay + parseInt(shelfLifeNo));
						break;
				}
				if (fullExpDate) {
					this.cut_off_Expirydate = moment(fullExpDate).format('YYYY-MM-DD')
					console.log(this.cut_off_Expirydate);
				}
			}
		},
		showSearchDR(e) {
			this.smartPOCheck = ''
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var code = (e.keyCode || e.which);
			// do nothing if it's an arrow key
			if (code == 37 || code == 38 || code == 39 || code == 40) {
				return;
			}

			this.DRerrors = '';
			this.isfoundDR = false;
			this.isnotfoundDR = true;
			this.addGRC.productid = '';
			this.isFoundProductInPO = false;
			if (this.selectedRow) {
				var drNo = this.selectedRow.invreferenceid;
			}

			if (this.addGRC.DRNo.trim() != '') {
				var drNo = this.addGRC.DRNo.trim();
			}
			if (drNo != '' && drNo.length > 4) {
				this.addGRC.DRNo = drNo;
				this.isLoading = true;
				this.input = ({
					'invreferenceid': drNo,
				});

				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'searchDR',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then((response) => {
						this.isLoading = false;
						if (response.data.errorCode == 0) {
							if (response.data.data.po.length == 0 || response.data.data.po[0] == null) {
								this.DRerrors = this.$t('grcList.drPoMapErr');
								this.isfoundDR = false;
								this.isnotfoundDR = false;
								this.merchantname = '';
								this.Merchantid = '';
							} else {
								if (response.data.data.multiseller == 1) {
									this.merchantname = response.data.data.merchantname
									this.Merchantid = response.data.data.merchantid
								}
								this.smartPOCheck = response.data.smartPo
								this.isfoundDR = true;
								this.isnotfoundDR = false;
								this.DRerrors = '';
								this.Merchantid = response.data.data.merchantid
								this.getPono = response.data.data.po
								this.clientid = response.data.data.clientid;
								this.loadRejectReason();
							}
						} else {
							this.merchantname = '';
							this.DRerrors = this.$t('grcList.validDrError');
							this.isfoundDR = false;
							this.isnotfoundDR = true;
						}
					})
				this.isLoading = false;
			}
		},

		addimagefun() {
			this.showaddimage = false;
			this.showfileselect = true
			this.showcameraselect = true
		},
		uploadImageGrc( uploadType) {
			this.showimagetype = this.imagetype[this.currentimageno]
			this.cameraSection = true
			this.file = null
			this.cameraImage = null
			if (uploadType == 'camera') {
				this.fileSection = false
			} else {
				this.fileSection = true
			}
		},

		uploadImage(uploadType) {

			this.file = null
			this.cameraImage = null
			if (uploadType == 'camera') {
				this.cameraSection = true
				this.fileSection = false
			} else {
				this.fileSection = true
			}
		},
		viewImageUpload(obj, url) {
			if (obj == 1) {
				this.$alert(this.$t('grcList.imgUploadErr'))
			} else {
				this.viewImage = true
				this.imageUrl = url
			}
		},
		handleFileUpload() {
			this.file = this.$refs.file.files[0];
			let imageTypes = ['image/jpeg', 'image/png']
			let imageFormat = this.file.type
			let checkFormat = imageTypes.includes(imageFormat)
			if (!checkFormat) {
				this.file = null
				document.getElementById('file').value = null
				this.$alert(this.$t('grcList.imgFormatErr'))
			}
		},
		async saveImage(imagetype, inputtype) {
			try {
				this.showaddimage = true
				this.showfileselect = false
				this.showcameraselect = false
				if (!this.imageCaptured && inputtype == 'camera') {
					this.$alert(this.$t('grcList.captureImg'))
					return false
				} else if (!this.file && inputtype == 'file') {
					this.$alert(this.$t('grcList.selectImg'))
					return false
				}
				if (inputtype == 'file') {
					var imgpath = document.getElementById('file');
					if (!imgpath.value == "") {
						var img = imgpath.files[0].size;
						var imgsize = img / 1024;
						if (imgsize > 4000) {
							this.$alert(this.$t('grcList.imgSize4mbErr'))
							document.getElementById('file').value = null
							this.file=null
							return false;
						}
					}
				}

				let imageString = ""
				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '');
				if (inputtype == "camera") {
					imageString = this.$refs.cameraImage.capture()
					if (!common_helper.calculateImageSize(imageString)) {
						this.$alert(this.$t('grcList.imgSize4mbErr'))
						this.isLoading7 = false
						imageString = ""
						return false
					}
				} else {
					let reader = new FileReader()
					reader.readAsDataURL(this.file)
					imageString = await new Promise((resolve, reject) => {
						reader.onload = function() {
							this.base64String = reader.result.replace("", "")
							resolve(this.base64String)
						}
					})
				}
				let inputpayload = {
					imagestring: imageString,
				}
				this.isLoading = true

		let Result = await common_helper.getRestApiResponse('POST', 'addimageforOutsideProduct', inputpayload, this.$alertify)
			if (Result && !Result.errorDATA) {
					if (Result.data.status == true) {
						this.imageCaptured = false
						this.cameraSection = false
						this.fileSection = false
						this.file = null
						if (imagetype == 'OutsideProductimage') {
							this.productUploadLabelUpload = true
							this.productUploadLabelUrl = Result.data.presignurl
							this.productUploadLabelUrlsave = Result.data.dburl
						}
						if(this.isfoundReject){
							this.StoreImagesandNumber(Result.data.presignurl,this.currentimageno)
						}
						this.$alertify.success(Result.data.data)
					} else {
						this.$alert(Result.data.msg)
						return false
					}
				}

			} catch (err) {
				console.log(err)
			}
		},

		StoreImagesandNumber(productUploadUrl,currentimageno){

			for (var i = 0; i < this.StoreimageUrls.length; i++) {
				if (i == this.currentimageno) {
					this.StoreimageUrls[i].imageno = currentimageno
					this.StoreimageUrls[i].url = productUploadUrl
					this.productUploadUrl = productUploadUrl
					this.imagetype[this.currentimageno]
				}
				}
		},
		myevent(productUploadLabelUrl) {
			if (productUploadLabelUrl != '') {
				this.isLoading = false
			}
		},
		RejectimageData() {
			if (this.totalImageCount > this.StoreimageUrls.length) {
			for (var i = 0; i < this.totalImageCount; i++) {
				this.StoreimageUrls.push({
					imageno: i,
					url: ""
				})
			}
		}
		},
		changeimage(data) {

			if (data == 'next' && this.currentimageno < 3) {
				this.currentimageno = this.currentimageno + 1
			} else if (data == 'prev' && this.currentimageno > 0) {
				this.currentimageno = this.currentimageno - 1
			}
			this.showimagetype = this.imagetype[this.currentimageno]
			this.productUploadUrl = this.StoreimageUrls[this.currentimageno].url

		},
		outsideproductmark() {
			this.outsideproductshow = true
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.isLoading = true;
			let input = {
				skuid: this.addGRC.productid.trim(),
				drno: this.addGRC.DRNo,
				clientid: this.clientid,
				warehouseid: this.userwarehouseid
			}
			axios({
					'method': 'POST',
					'url': apiUrl.api_url + 'CheckProductfound',
					'data': input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(async (response) => {
					this.isLoading = false;
					if (response.data.status == false) {
						this.outsideproductFoundinNop = false
						if(response.data.data.result1.length > 0){
						this.outsideproductdetails.DrRecievedqty = response.data.data.result1[0].totalreceivequantity
						}
						this.Skuid = this.addGRC.productid
					} else if (response.data.status == true) {
						this.outsideproductFoundinNop = true
						if (response.data.data.result) {
							this.Skuid = this.outsideproductdetails.skuid = response.data.data.result[0].eancode
							this.mrp = this.outsideproductdetails.mrp = response.data.data.result[0].mrp
							this.Skuname = this.outsideproductdetails.skuname = response.data.data.result[0].productname
							this.color = this.outsideproductdetails.color = response.data.data.result[0].color
							this.brand = this.outsideproductdetails.brand = response.data.data.result[0].brand
							this.Size = this.outsideproductdetails.size = response.data.data.result[0].size
							// this.outsideproductdetails.qty = response.data.data.result[0].qty
							this.outsideproductdetails.DrRecievedqty = response.data.data.result1[0].totalreceivequantity
							this.productUploadLabelUrl = await this.ShowImage(response.data.data.result[0].coverimage)

						}
					}
				})

		},
		ShowImage(imagedata) {
			return new Promise((resolve, reject) => {

				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '');
				this.pageno = 0;
				if (imagedata == null || imagedata == '' || imagedata == undefined) {
					this.$alertify.error(this.$t('common.imageErr'));
					return false;
				}
				this.isLoading = true
				this.input = ({
					's3url': imagedata,
				});
				axios({
					method: 'POST',
					'url': apiUrl.api_url + 'viewImagebyurl',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				}).then((result) => {
					if (result.data.Status) {
						resolve(result.data.url)
					} else {
						this.$alertify.error(this.$t('common.imageErr'));
						this.isLoading = false;
					}

				})
			})
		},
		onlyFormrp($event) {
			let keyCode = ($event.keyCode ? $event.keyCode : $event.which);

			// only allow number and one dot
			if ((keyCode < 48 || keyCode > 57) && (keyCode !== 46 || this.mrp.indexOf('.') != -1)) { // 46 is dot
				$event.preventDefault();
			}

			// restrict to 2 decimal places
			if (this.mrp != null && this.mrp.indexOf(".") > -1 && (this.mrp.split('.')[1].length > 1)) {
				$event.preventDefault();
			}

		},
		outsideproductsave() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.$validator.validateAll().then((result) => {
				if (this.Skuid == '') {
					return false;
				}
				if (this.Skuname == '') {
					return false;
				}

				if (this.mrp == '' || this.mrp < 0) {
					if (this.mrp < 0) {
						this.$alertify.error(this.$t('grcList.negativeMRPErr'));
					}
					return false;
				}
				if (this.Recievedqty <= 0) {
					this.$alertify.error(this.$t('grcList.receivedQuantErr'));
					return false;
				}
				this.isLoading7 = true;
				let input = {
					clientid: this.clientid,
					warehouseid: this.userwarehouseid,
					skuid: this.Skuid,
					Skuname: this.Skuname,
					brand: this.brand,
					mrp: this.mrp,
					color: this.color,
					size: this.Size,
					merchantid: this.Merchantid,
					Recievedqty: this.Recievedqty,
					invreferenceid: this.addGRC.DRNo.trim(),
					createdby: this.createdbyEmail,
					coverimg: this.productUploadLabelUrlsave,
				}
				axios({
						'method': 'POST',
						'url': apiUrl.api_url + 'pushoutsideproduct',
						'data': input,
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then((response) => {
						this.isLoading7 = false;
						if (response.data.data.status == false) {
							this.$alertify.error(this.$t('grcList.dataRecorded'))
							this.resetScope();
						} else if (response.data.data.status == true) {
							this.outsideproductshow = false;
							this.$alertify.success(this.$t('grcList.dataSubmitSuccess'));
							this.resetScope();

						}
					})
			})


		},

		resetform() {
			this.productUploadLabelUrlsave = ''
			this.Skuid = '',
				this.Skuname = '',
				this.brand = '',
				this.color = '',
				this.mrp = '',
				this.Size = '',
				this.Recievedqty = ''
			this.productUploadLabelUpload = false;
			this.showshelflifeflag = false;
			this.productUploadLabelUrl = ''
			this.$validator.reset();
		},
		resetform1() {
			this.Recievedqty = ''
		},
		captureImage() {
			this.$refs.cameraImage.pause()
			this.imageCaptured = true
		},
		resetImage() {
			this.imageCaptured = false
			this.$refs.cameraImage.resume()
		},
		showSearchProduct(e) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var code = (e.keyCode || e.which);
			// do nothing if it's an arrow key
			if (code == 37 || code == 38 || code == 39 || code == 40) {
				return;
			}
			this.IDerrors = '';
			this.isFoundProductInPO = false;
			this.isNotFoundProductInPO = true;
			this.isProductNotInPO = false;
			this.isfoundMRP = false;
			this.addGRC.MRP = 0;
			this.shelfLifeCheck = false;
			this.lotControlCheck = false;
			this.shelfandDurationcheck = false;
			this.expControlCheck = false;
			this.shelflifeuomflag = false;
			this.isExpiry = true;
			this.isExpiryCol = false;
			this.isshelflife = false;
			this.outsideproductshow = false;
			this.resetform();
			//////
			this.addGRC.acceptedqty = '';
			this.addGRC.checkedqty = '';
			this.addGRC.rejectedqty = '';
			this.rejectReason = [];
			this.addGRC.holdqty = '';
			this.addGRC.shortqty = 0;
			this.addGRC.lotno = '';
			///////
			this.addGRC.shelfLife = '';
			this.addGRC.mfgdate = '';
			this.addGRC.expdate = '';
			this.addGRC.lotControl = '';
			this.productColor = '';
			this.productSize = '';
			this.productId = '';
			if (this.addGRC.productid != '') {
				if (this.addGRC.productid) {
					this.productCheckIcon = this.loadingText;
					this.isLoading = true;
					this.input = ({
						'productid': this.addGRC.productid.trim(),
						'invreferenceid': this.addGRC.DRNo.trim(),
						'actionType': 'productID',
						'clientid': this.clientid,
						'warehouseid': this.userwarehouseid
					});
					axios({
							method: 'POST',
							'url': apiUrl.api_url + 'ProductList',
							'data': this.input,
							headers: {
								'Authorization': 'Bearer ' + myStr
							}
						})
						.then((response) => {
								this.isLoading = false;
								if (response.data.status) {
									this.IDerrors = '';
									this.ShelflifeErrors = '';
									this.isNotFoundProductInPO = false;
									this.isFoundProductInPO = true;
									this.productCheckIcon = this.rightIcon;
									this.ThreshholdExp = response.data.ProductExpiryThreshold;
									this.addGRC.pono = response.data.result[0].pono;
									this.addGRC.inwardid = response.data.result[0].inwardid;
									this.addGRC.invoiceno = response.data.result[0].invoiceno;
									this.addGRC.productdesc = response.data.result[0].productdescription;
									this.productDescription = response.data.result[0].productdescription;
									this.addGRC.productImage = response.data.result[0].productimage;
									this.addGRC.pickPoNo = response.data.result[0].pono;
									this.addGRC.merchantid = response.data.result[0].merchantid;
									this.checkProductMrp = response.data.result[0].mrp;
									this.addGRC.eancode = response.data.result[0].eancode;
									this.addGRC.productname = response.data.result[0].productname;

									this.productColor = response.data.result[0].color;
									this.productSize = response.data.result[0].size;
									this.productId = response.data.result[0].productid;
									this.addGRC.expdate = response.data.result[0].expirydate;
									this.addGRC.shelflifeduration = response.data.result[0].shelflifeduration;
									this.ShelfLife = '';
									this.ShelfLifeuom1 = '';
									// this.ThreshholdExp=

									if(response.data.result[0].ismrptracked){
										this.isMrpTrue = true;
									}

									if (response.data.result[0].shelflifeuom) {
										this.addGRC.shelflifeuom = response.data.result[0].shelflifeuom.trim();

									}

									if (response.data.result[0].nocontrol == 1) {
										if (response.data.result[0].expirycontrolled > 0 && (this.addGRC.shelflifeduration != null && this.addGRC.shelflifeduration != null) && (this.addGRC.shelflifeuom != '' && this.addGRC.shelflifeuom != '')) {
											this.isExpiryCol = true;
											this.expControlCheck = true;
											this.addGRC.shelfLife = this.addGRC.shelflifeduration + " " + this.addGRC.shelflifeuom;
										}
										if (response.data.result[0].expirydate != null && response.data.result[0].expirydate != '') {
											this.addGRC.expdate = response.data.result[0].expirydate;
											this.calculateMfgDate();
										}
										if (response.data.result[0].expirycontrolled && response.data.result[0].expirycontrolled > 0 && (!this.addGRC.shelflifeduration || !response.data.result[0].shelflifeuom)) {
											this.isExpiryCol = false;
											this.showshelflifeflag = true;
											this.shelflifecheckfordate = false;

										}

										if (response.data.result[0].expirycontrolled > 0) {
											this.expControlCheck = true;
											this.addGRC.expdate = this.dateFormatFRT2(this.addGRC.expdate)
											this.calculateMfgDate();
										}
										if (response.data.result[0].lotcontrol > 0) {
											this.lotControlCheck = true;
											// this.addGRC.lotControl = response.data.result[0].nocontrol;
										}
									} else {
										this.isExpiry = false;
									}
									if (response.data.result[0].warehouseid) {
										this.addGRC.warehouseid = response.data.result[0].warehouseid;
									}
									if(this.isMrpTrue){
										var poList = [];
										this.mrpOptions = [{
											value: '',
											text: this.$t('stockTransfer.mrpError'),
										}];
										for (var i = 0; i < response.data.result.length; i++) {
											this.mrpOptions.push({
												value: response.data.result[i].mrp,
												text: response.data.result[i].mrp,
											});
											if (poList.find(each => each.pono === response.data.result[i].pono)) {} else {
												poList.push(response.data.result[i]);
											}
										}
										this.addGRC.MRP = '';
										this.selectPoNoList = poList;
									}else{
										this.addGRC.MRP = response.data.result[0].mrp;
										this.isfoundMRP = true;
										this.searchProductMRP();
									}
								} else {
									if (response.data.errorCode == -1) {
										this.productCheckIcon = this.wrongIcon;
										this.IDerrors = this.$t('grcList.itemNotInPO') //response.data.message;
										this.productData = response.data.data;
										return false;
									}
									if (response.data.errorCode == -2) {
										this.outsideproduct = false;
										this.productCheckIcon = this.wrongIcon;
										this.IDerrors = response.data.message;
										this.productData = response.data.data;
										return false;
									}
									else {
										this.productCheckIcon = this.wrongIcon;
										this.outsideproduct = true
										this.IDerrors = this.$t('grcList.invalidProduct') //response.data.message;
										this.productData = false;
										return false;
									}
								}
							},
							error => {
								this.isLoading = false;
								this.productCheckIcon = this.wrongIcon;
								this.IDerrors = this.$t('grcList.invalidScannedProduct');
								return false;
							});
				} else {
					this.IDerrors = this.$t('grcList.productIDFieldNumber');
					return false;
				}
			} else {
				this.IDerrors = this.$t('grcList.productIDFieldRequired');
				return false;
			}
			this.getElementByIdFn("MRP", 0);
		},
		getconfirmsaveshelflife() {
			if (this.ShelfLife == "") {
				this.$alertify.error(this.$t('grcList.enterShelflifeDuration'));
				this.ShelfLifeuom1 = ''
				return false;
			} else if (this.ShelfLife <= 0) {
				this.$alertify.error(this.$t('grcList.shelflifeDurationErr'));
				this.ShelfLifeuom1 = ''
				document.getElementById('ShelfLife').value = ''
				this.ShelfLife = ''

			} else {
				var msg = this.$t('grcList.saveShelflife');
				this.$confirm(msg).then((confirm) => {
					if (confirm) {
						this.saveshelflife()
					}
				}).catch(() => {
					this.ShelfLifeuom1 = '';
					document.getElementById('ShelfLife').value = ''
					this.ShelfLife = ''
				})
			}
		},
		saveshelflife() {

			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.input = ({
				'searchKey': this.addGRC.productid.trim(),
				'clientid': this.clientid,
				'shelflifeduration': this.ShelfLife,
				'shelflifeuom': this.ShelfLifeuom1
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'saveshelflife',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data.status == true) {
						this.$alertify.success(result.data.message)
						this.showshelflifeflag = false;
						this.shelflifecheckfordate = true;
						this.showSearchProduct('')
					} else {
						this.$alertify.error(result.data.message)
					}
				})
		},
		saveGRC(scope) {
			var mfgcheck = '';
			var expcheck = '';
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var grcStatus = "done";
			var userdetail = this.getLocalUserData();
			var mfgcheck = '';
			var expcheck = '';
			if (this.showshelflifeflag == true && (this.ShelfLife == "" || this.ShelfLifeuom1 == "")) {
				this.$alertify.error(this.$t('grcList.shelflifeRequired'))
				return false;
			}
			this.$validator.validateAll(scope).then(async(result) => {
				if (result) {
					this.rejectReasonErrors = this.holdReasonErrors = this.expiryDtlErrors = '';
					if ((this.addGRC.rejectedqty != '' && this.addGRC.rejectedqty != 0) && this.rejectReason.length == 0) {
						this.rejectReasonErrors = this.$t('grcList.selectValidReasonRej');
						return false;
					}
					if ((this.addGRC.holdqty != '' && this.addGRC.holdqty != 0) && this.holdReason.length == 0) {
						this.holdReasonErrors = this.$t('grcList.selectValidReasonHold');
						return false;
					}
					if ((this.addGRC.shortqty != '' && this.addGRC.shortqty != 0) && this.shortReason!='') {
						this.holdReasonErrors = this.$t('grcList.selectValidReasonHold');
						return false;
					}
					if (this.isfoundReject && this.addGRC.rejectedqty > 0) {
						let Isimageupload = await this.isImageuploaded();
                        if(!Isimageupload){
							this.$alert(this.$t('grcList.atleastOneRejectImage'));
							return false
						}
					}
					if (this.addGRC.rejectedqty == '') {
						this.addGRC.rejectedqty = 0;
					}
					if (this.addGRC.shortqty == '') {
						this.addGRC.shortqty = 0;
					}
					if (this.addGRC.holdqty == '') {
						this.addGRC.holdqty = 0;
					}

					if (this.lotControlCheck == true || this.expControlCheck == true) {
						this.addGRC.lotControl = 1;

					} else {
						this.addGRC.lotControl = 0;

					}
					if (userdetail) {
						this.loginUserEmail = userdetail.email;
						this.addGRC.warehouseid = userdetail.warehouseid;
					}
					if (this.addGRC.mfgdate || this.addGRC.expdate) {
						mfgcheck = moment(this.addGRC.mfgdate).format('YYYY-MM-DD')
						expcheck = moment(this.addGRC.expdate).format('YYYY-MM-DD')
					}
					if(!this.isfoundReject){
						this.StoreimageUrls=[]
					}

					this.input = ({
						pono: this.addGRC.pickPoNo,
						invreferenceid: this.addGRC.DRNo,
						inwardid: this.addGRC.inwardid,
						invoiceno: this.addGRC.invoiceno,
						productid: this.productId.toString(),
						invoicequantity: this.addGRC.invoiceQty,
						checkedquantity: this.addGRC.acceptedqty, //(old key value => checkedqty)
						totalreceivequantity: this.addGRC.checkedqty, //(old key value => acceptedqty)recive quantity
						rejectedquantity: this.addGRC.rejectedqty,
						onholdquantity: this.addGRC.holdqty,
						shortqty: this.addGRC.shortqty,
						mrp: this.addGRC.MRP,
						createdby: this.loginUserEmail,
						lastmodifiedby: this.loginUserEmail,
						grcstatus: grcStatus,
						warehouseid: this.addGRC.warehouseid,
						rejectReason: this.rejectReason,
						holdReason: this.holdReason,
						manufacturingdate: mfgcheck ? mfgcheck : "",
						expirydate: expcheck ? expcheck : "",
						lotControl: this.addGRC.lotControl,
						lotno: this.addGRC.lotno,
						shelfLife: this.addGRC.shelfLife,
						clientid: this.clientid,
						polinenumber: this.addGRC.productlinenumber,
						merchantid: this.addGRC.merchantid,
						rejectedimages:this.StoreimageUrls
					});
					this.isLoading = true;
					axios({
							method: 'POST',
							'url': apiUrl.api_url + 'CreateGRC',
							'data': this.input,
							headers: {
								'Authorization': 'Bearer ' + myStr

							}
						})
						.then(async (response) => {
							this.isLoading = false;
							if (response.data.errorCode == 0) {
								await this.opencrossdockmodal(this.productId.toString(),this.addGRC.acceptedqty,response.data.GRCList.mrp)
								if(this.crossdockqty > 0){
									await this.confirmmovement()
									await this.$alertify.success(response.data.msg);
								   this.$validator.reset(scope);
								}else{
								   await this.$alertify.success(response.data.msg);
								   this.$validator.reset(scope);
								   this.resetScope();
								}	
							
							} else {
								await this.$alertify.error(response.data.msg);
								this.$validator.reset(scope);
							   this.resetScope();
							}
							
						})
						.catch((httpException) => {
							this.isLoading = false;
							this.$alertify.error(this.$t('grcList.exceptionErr'));
						});
				} else {
					return false;
				}
			});
		},

		notInPOTrigger(condition) {
			if (condition == 'notinpo') {
				this.isProductNotInPO = true;
				this.notinpo.mrp = 0;
				this.notinpo.qty = 0;

				this.notinpoError.qty = false;
				this.notinpoError.qty = false;
			} else {
				this.resetScope();
			}
		},

		saveNotInPO() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.notinpoError = {
				mrp: false,
				qty: false,
			};
			if (this.notinpo.mrp < 0) {
				this.$alertify.error(this.$t('grcList.negativeMRPErr'))
				this.notinpo.mrp = 0;
				return false
			}
			if (this.notinpo.mrp && this.notinpo.qty) {
				let userdetail = this.getLocalUserData();
				if (userdetail) {
					let input = {
						clientid: this.clientid,
						warehouseid: userdetail.warehouseid,
						invreferenceid: this.addGRC.DRNo,
						productid: this.productData.productid,
						qty: this.notinpo.qty,
						mrp: this.notinpo.mrp,
						createdby: userdetail.email,
					};
					this.isLoading = true;
					axios({
							'method': 'POST',
							'url': apiUrl.api_url + 'CreateNotInPO',
							'data': input,
							headers: {
								'Authorization': 'Bearer ' + myStr
							}
						})
						.then((response) => {
							this.isLoading = false;
							if (response.data.errorCode == 0) {
								this.$alertify.success(response.data.msg);
							} else {
								this.$alertify.error(response.data.msg);
							}
							this.resetScope();
						})
						.catch((httpException) => {
							this.isLoading = false;
							this.$alertify.error(this.$t('grcList.exceptionErr'));
						});
				} else {
					this.$alertify.error(this.$t('grcList.loginToProceed'));
					return false;
				}
			} else {
				if (!this.notinpo.mrp || this.notinpo.mrp <= 0)
					this.notinpoError.mrp = 'Please enter MRP';
				if (!this.notinpo.qty || this.notinpo.qty <= 0)
					this.notinpoError.qty = 'Please enter quantity';
				return false;
			}
		},


		isNumeric: function(n) {
			return !isNaN(parseFloat(n)) && isFinite(n);
		},

		loadRejectReason() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.rejectOptions = []
			this.holdOptions = []
			this.input = ({
				reasonType: 'reject',
				clientid: this.clientid
			});
			this.isLoading = true;
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'rejectReasonList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr

					}
				})
				.then(result => {
					this.isLoading = false;
					if (result.data.status) {
						for (var i = 0; i < result.data.result.length; i++) {
							this.rejectOptions.push(result.data.result[i].reasonname);
						}
						this.rejectedReasonList = result.data;
					}
				}, error => {
					this.isLoading = false;
					//console.error(error)
				});

			this.input = ({
				reasonType: 'hold',
				clientid: this.clientid
			});
			this.isLoading = true;
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'rejectReasonList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr

					}
				})
				.then(result => {
					this.isLoading = false;
					if (result.data.status) {
						for (var i = 0; i < result.data.result.length; i++) {
							this.holdOptions.push(result.data.result[i].reasonname);
						}
						this.holdReasonList = result.data;
					}
				}, error => {
					this.isLoading = false;
					//console.error(error)
				});
		},

		searchProduct(scope) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.searchProductFltError = "";
			this.addGRC.productid = '';

			this.isFoundProductInPO = false;
			this.isNotFoundProductInPO = true;

			this.isfoundMRP = false;
			this.addGRC.MRP = 0;

			this.MRPerrors = "";
			this.MRPsuccess = "";

			if (this.searchProductFlt != '') {
				if (this.isNumeric(this.searchProductFlt)) {
					this.input = ({
						searchKey: this.searchProductFlt.trim()
					});
					this.isLoading = true;
					axios({
							method: 'POST',
							'url': apiUrl.api_url + 'productSearch',
							'data': this.input,
							headers: {
								'Authorization': 'Bearer ' + myStr

							}
						})
						.then(result => {
							this.isLoading = false;
							if (result.data.status) {
								this.addGRC.productid = result.data.result[0].productid;
								this.showSearchProduct('');
								this.productSearchModal = false;
								this.getElementByIdFn("productid", result.data.result[0].productid);
							} else {
								this.searchProductFltError = result.data.message;
							}
						}, error => {
							this.isLoading = false;
							console.error(error)
						});
				} else {
					this.searchProductFltError = this.$t('grcList.productIdorEANcodeErr');
				}
			} else {
				this.searchProductFltError = this.$t('grcList.productIdorEANcodeRequired');
			}
		},

		searchProductMRP() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.MRPerrors = "";
			this.MRPsuccess = "";
			this.isError = true;
			this.isfoundMRP = '';
			this.isnotfoundMRP = true;
			this.addGRC.invoiceQty = ''
			this.isFoundInvoiceQty = false

			this.grcCheckedQty = 0
			this.grcReceivedQty = 0
			this.grcRejectedQty = 0
			this.grcHoldQty = 0
			this.grcShortQty = 0
			if (this.expControlCheck == true) {
				this.thresholdValueexp(this.ThreshholdExp)
			}
			if (this.isNumeric(this.addGRC.MRP)) {
				if (this.addGRC.MRP > 0) {
					this.input = ({
						'productid': this.addGRC.productid.trim(),
						'invreferenceid': this.addGRC.DRNo.trim(),
						'mrp': this.addGRC.MRP.trim(),
						'pono': this.addGRC.pickPoNo.trim(),
						'actionType': 'MRP',
						'clientid': this.clientid,
						'warehouseid': this.userwarehouseid,
					});
					axios({
							method: 'POST',
							'url': apiUrl.api_url + 'ProductList',
							'data': this.input,
							headers: {
								'Authorization': 'Bearer ' + myStr
							}
						})
						.then((response) => {

								if (response.data.status) {
									this.potolerance = response.data.potolerance;
									this.isError = '';
									this.isnotfoundMRP = '';
									this.MRPerrors = '';
									//this.MRPsuccess = "MRP entered successfully";
									this.isfoundMRP = true;
									this.addGRC.productqty = response.data.result[0].quantity;
									this.invoicePQuantity = response.data.result[0].quantity;
									this.addGRC.productlinenumber = response.data.result[0].productlinenumber;
									this.addGRC.merchantid = response.data.result[0].merchantid;
									this.maxpoqty = this.invoicePQuantity + Math.round(this.invoicePQuantity * this.potolerance.potolerance / 100);
									// this.existsProductGrcCheck();
									if (response.data.resultGRC.length > 0) {
										this.addGRC.invoiceQty = response.data.resultGRC[0].invoicequantity;
										this.isFoundInvoiceQty = true

										this.grcCheckedQty = response.data.resultGRC[0].checkedquantity
										this.grcReceivedQty = response.data.resultGRC[0].totalreceivequantity
										this.grcRejectedQty = response.data.resultGRC[0].rejectedquantity
										this.grcHoldQty = response.data.resultGRC[0].onholdquantity
										this.grcShortQty = response.data.resultGRC[0].lessquantity
										this.maxpoqty -= this.grcReceivedQty;
                                        if(response.data.resultGRC[0].crossdockqty > 0){
											this.crossdockquantity = response.data.resultGRC[0].crossdockqty
											this.acceptedqty =response.data.resultGRC[0].checkedquantity
										}
									}
								} else {
									this.MRPerrors = response.data.message;
									return false;
								}
							},
							error => {
								this.MRPerrors = this.$t('grcList.mrpPOerr');
								return false;
							})
				} else {
					this.MRPerrors = this.$t('grcList.mrpRequired');
					return false;
				}
			} else {
				//this.MRPerrors = 'MRP should be decimal.  Enter a correct MRP';
			}
		},

		existsProductGrcCheck() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');


			this.isFoundTotalCheckqty = false;
			this.isLoading = true;
			this.input = ({
				'productid': this.addGRC.productid.trim(),
				'invreferenceid': this.addGRC.DRNo.trim(),
				'mrp': this.addGRC.MRP.trim(),
				'pono': this.addGRC.pickPoNo.trim()
			});

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'existsProductGrcCheck',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})

				.then((response) => {
						this.isLoading = false;
						if (response.data.status) {
							if (response.data.result[0].remainqty > 0) {
								this.isFoundTotalCheckqty = true;
								this.totalCheckedQty = response.data.result[0].checkedquantity;
								this.totalRemainForThis = response.data.result[0].remainqty;
								this.addGRC.productqty = response.data.result[0].remainqty;
								return true;
							}
						} else {
							return false;
						}
					},
					error => {
						this.isLoading = false;
						return false;
					});
		},

		resetMrp() {
			this.$validator.reset();
			this.errors.clear();
			this.isfoundMRP = '';
			this.getElementByIdFn("MRP", 0);
		},

		openSearchProductModal(event) {
			this.productSearchModal = true;
			this.getElementByIdFn("searchProductFlt", "");
			this.searchProductFlt = '';
		},

		validateQty(check) {
			this.rejectQtyerrors = '';
			this.holdQtyerrors = '';
			if (check == "currentCheckQty") {
				if (this.addGRC.checkedqty > this.maxpoqty -this.grcShortQty) {
					this.checkQtyerrors = this.$t('grcList.outOfOverReceiptTolerance');
				}
				else
				if (this.addGRC.checkedqty > this.maxpoqty && this.user_type != this.potolerance.role) {
					this.checkQtyerrors = this.$t('grcList.outOfOverReceiptTolerance');
				} else {
					this.checkQtyerrors = '';
				}
				if (this.isexpirycutoff == false) {
					this.showRejectedQuantity(false);
				}
				this.addGRC.acceptedqty = 0;
				this.getElementByIdFn("acceptedqty", 0);
			} else if (check == "acceptqty") {
				this.showRejectedQuantity(false);
				this.addGRC.rejectedqty = 0;
				this.addGRC.holdqty = 0;
				if (this.addGRC.acceptedqty > 0) {
					this.showicon = true;
				} else {
					this.showicon = false;
				}
				if (parseFloat(this.addGRC.checkedqty) != parseFloat(this.addGRC.acceptedqty) && this.addGRC.checkedqty != '' && this.addGRC.acceptedqty != '') {
					this.showRejectedQuantity(true);
				}
			} else if (check == "rejectqty") {
				if(this.checkQtyerrors){
					this.hideRejectedBarcode = true
				}else{
					this.hideRejectedBarcode = false
				}
				if (parseFloat(this.addGRC.rejectedqty) > (parseFloat(this.addGRC.checkedqty) - parseFloat(this.addGRC.acceptedqty)) && this.addGRC.rejectedqty > 0) {
					this.rejectQtyerrors = this.$t('grcList.totalRejQtyErr');
					this.hideRejectedBarcode = true
					//this.addGRC.holdqty = 0;
				}
			} else if (check == "shortqty") {
				//console.log("Product Qty-->",this.addGRC.productqty," ",this.addGRC.checkedqty," ", this.grcShortQty," ",this.addGRC.shortqty)
				if(parseFloat(this.addGRC.productqty) - parseFloat(this.addGRC.checkedqty) - parseFloat(this.grcShortQty) <parseFloat(this.addGRC.shortqty)){
					this.shortQtyerrors = this.$t('grcList.invalidShortQty');
					this.showicon = false;
				}
				else
				{
					this.shortQtyerrors = ''
					this.showicon = true;
				}

			} else if (check == "holdqty") {
				if (parseFloat(this.addGRC.holdqty) != (parseFloat(this.addGRC.checkedqty) - (parseFloat(this.addGRC.acceptedqty) + parseFloat(this.addGRC.rejectedqty))) && this.addGRC.holdqty > 0) {
					this.holdQtyerrors = this.$t('grcList.invalidHoldQty');
				}
			}
			console.log(this.showicon)
		},
		openmodal(data) {
			this.quantity = '';
			document.getElementById('quantity').disabled = true;
			this.showmodal = true;
			if(data > 1000){
				this.quantity = 1000
				this.$alertify.error(this.$t('editedjson.printQtyvalidation'));
			}else{
				this.quantity = data;
			}
			this.$validator.reset();
			this.errors.clear();
		},
		closemodal() {
			this.quantity = '';
			document.getElementById('quantity').disabled = false;
			// this.$validator.reset();
			// this.errors.clear();
			this.showmodal = false;
		},
		async  checkCrossDockEnabled(){
			return new Promise((resolve, reject) => {
				var userToken = window.localStorage.getItem('userToken');
				var myStr = userToken.replace(/"/g, '');
				this.input1 = {};
				this.input1.clientid = this.clientid;
				this.input1.warehouseid =this.userwarehouseid;				
				axios({
				  method: 'GET',
				  'url': `${apiUrl.api_url}checkCrossDockEnabled`,
				  'params': this.input1,
				  headers: {
					'Authorization': 'Bearer ' + myStr,
				  },
				})
				.then(result => {
				  if (result.data) {
					this.checkCrossDock = result.data.data;
					resolve(this.checkCrossDock); 
				  } else {
					reject('Data not found');
				  }
				})
				.catch(error => {
				  reject(error); // Reject the Promise with the error
				});
			  });
			
		},
		async opencrossdockmodal(productid,acceptedqty,mrp) {
			return new Promise(async (resolve, reject) => {
				try {
					let check = await this.checkCrossDockEnabled();
	
					if (check === true) {
						await this.getCrossDockDetails(productid, acceptedqty,mrp);
						if(this.crossdockqty > 0){
							this.crossdockmodal = true;
						}

						this.$validator.reset();
						this.errors.clear();

							resolve(); 
		
					} else {
						resolve(); 
					}
				} catch (error) {
					console.error(error);
					reject(error);
				}
			});
	
		},
		closecrossdockmodal(){
			this.crossdockmodal = false;
			setTimeout(() => {
				this.$alertify.success(this.crossdockmsg);
				this.resetScope();
			  }, 1000);
		},
		async getCrossDockDetails(productid, acceptedqty,mrp) {
			return new Promise(async (resolve, reject) => {
				this.crossdockdata = [];
				this.crossdockqty = 0;
				var userToken = window.localStorage.getItem('userToken');
				var myStr = userToken.replace(/"/g, '');
				this.input1 = {};
				this.input1.clientid = this.clientid;
				this.input1.warehouseid = this.userwarehouseid;
				this.input1.productid = this.productId;
				this.input1.acceptedqty = acceptedqty;
		        this.input1.mrp = mrp
				try {
					const response = await axios({
						method: 'GET',
						url: `${apiUrl.api_url}getCrossDockDetails`,
						params: this.input1,
						headers: {
							'Authorization': 'Bearer ' + myStr,
						},
					});
		
					if (response.data) {
						this.crossdockdata = response.data.data;
						this.crossdockqty = this.crossdockdata.reduce((acc, item) => acc + item.quantity, 0);
						this.crossdockquantity = this.crossdockquantity + this.crossdockqty;
						this.acceptedqty = parseFloat(this.acceptedqty) + parseFloat(this.addGRC.acceptedqty);
						if(this.crossdockqty > 0){
							this.crossdockmodal = true;
						}
						resolve();
					}
				} catch (error) {
					this.isLoading = false;
					console.error(error);
					reject(error);
				}
			});
		},
		async confirmmovement(){
			try {
				var userToken = window.localStorage.getItem('userToken');
				var myStr = userToken.replace(/"/g, '');
				
				let params = {
					crossdockdata: [...this.crossdockdata],
					drno: this.addGRC.DRNo,
					pono: this.addGRC.pickPoNo.trim(),
					inwardid: this.addGRC.inwardid,
					clientid: this.clientid,
					warehouseid: this.userwarehouseid,
					useremail: this.createdbyEmail,
				};
		
				const response = await axios({
					method: 'PUT',
					url: `${apiUrl.api_url}updateMoveMaterial`,
					data: params,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					},
				});
		
				if (response.data) {
					this.crossdockmsg = response.data.msg					
				} else {
					this.closecrossdockmodal();
				}
		
				return response; // This line may not be necessary, depending on your needs
			} catch (error) {
				this.isLoading = false;
				console.error(error);
				throw error; // Propagate the error to the caller
			}
		},
		movement(){
            this.closecrossdockmodal();
		},
		submitprint() {
			var qty = this.quantity;
			var productid = parseInt(this.addGRC.productid);
			var mrp = this.addGRC.MRP
			this.printproduct(qty, productid, mrp)
		},
		onSubmit: function() {
			this.$validator.validateAll().then(() => {
				console.log('form is valid', this.model)
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		},
		printproduct(qty, productid, mrp) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var clientdata =window.localStorage.getItem('clientList')
			var bytes = CryptoJS.AES.decrypt(clientdata.toString(), 'Key');
			var plaintext = bytes.toString(CryptoJS.enc.Utf8);
			var decryptClientList = JSON.parse(plaintext);	
			var clientname=decryptClientList.filter(ele=>ele.clientid == this.clientid)	
			this.input = ({
				clientname: clientname[0].clientname,
				Eancode:this.addGRC.eancode,
				productname:this.addGRC.productname,
				qty: qty
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url +'generateProductBarcode',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					},
					responseType:"blob"
				})
				.then(result => {
					if (result.data) {
						const file = new Blob([result.data], { type: "application/pdf" });
						//Build a URL from the file
						const fileURL = URL.createObjectURL(file);
						//Open the URL on new Window
						 const pdfWindow = window.open();
						 pdfWindow.location.href = fileURL;
						this.$alertify.success(this.$t('editedjson.printSuccess'));
						this.closemodal();
					} else {
						this.closemodal();
					}
				}, error => {
					this.isLoading = false;
					console.error(error)
				})
		},
		showRejectedQuantity(res) {
			this.getElementByIdFn("rejectedqty", 0);
			this.getElementByIdFn("holdqty", 0);
			if (res) {
				this.isfoundReject = true;
				this.RejectimageData()
			} else {
				this.isfoundReject = false;
			}
		},

		openExpiryModal(event) {
			this.expiryDetailsModal = true;
		},



		checkRejectHoldQty() {
			if(Number(this.addGRC.checkedqty)==0 && Number(this.addGRC.shortqty)>0 && Number(this.grcCheckedQty)==0){
				if(Number(this.addGRC.productqty) - Number(this.grcShortQty)>=Number(this.addGRC.shortqty))
				{
					return true;
				} else {
					console.log("Fianl false--1")
					return false;
				}
			} 
			else if((Number(this.addGRC.shortqty)>0 || Number(this.grcShortQty)>0) && (Number(this.addGRC.checkedqty)>0 ||Number(this.addGRC.shortqty)>0) )
			{
				if( Number(this.addGRC.productqty) >= (Number(this.grcCheckedQty) + Number(this.grcShortQty) + Number(this.addGRC.shortqty) + Number(this.addGRC.checkedqty)))
				{

					return true;
				}
				else
				{
					console.log("Fianl false--2")
					return false;
				}
			}
			else
			if ((parseFloat(this.addGRC.checkedqty) >= parseFloat(this.addGRC.acceptedqty)) && (parseFloat(this.addGRC.rejectedqty) + parseFloat(this.addGRC.holdqty) + parseFloat(this.addGRC.acceptedqty)) == parseFloat(this.addGRC.checkedqty) && this.addGRC.checkedqty > 0) {
				if (this.addGRC.checkedqty > this.maxpoqty && this.user_type != this.potolerance.role) {
					console.log("Fianl false--3")
					return false;
				} else {
					return true;
				}
			} 
			else {
				//console.log("Fianl -->",this.addGRC.productqty," p-Recve->",this.grcCheckedQty," p-short->",this.grcShortQty," c-short->",this.addGRC.shortqty," c-checked ->",this.addGRC.checkedqty)
				//console.log((Number(this.grcCheckedQty) + Number(this.grcShortQty) + Number(this.addGRC.shortqty) + Number(this.addGRC.checkedqty)))
				console.log("Fianl false--")
				return false;
			}
		},

		resetScope() {
			var self = this;
			self.isfoundDR = false;
			self.isnotfoundDR = false;
			self.isFoundProductInPO = false;
			self.isNotFoundProductInPO = false;
			self.isfoundMRP = false;
			self.isnotfoundMRP = false;
			self.isfoundReject = false;
			self.shelfLifeCheck = false;
			self.isExpiry = true;
			self.lotControlCheck = false;
			self.expControlCheck = false;
			self.isExpiryCol = false;
			Object.keys(this.addGRC).forEach(function(key, index) {
				if (key == "productqty" || key == "checkedqty" || key == "acceptedqty" || key == "rejectedqty" || key == "holdqty" || key == "warehouseid" || key == "shortqty") {
					self.addGRC[key] = 0;
				} else {
					if (self.addGRC[key] != "DRNo") {
						self.addGRC[key] = '';
					}
				}
			});
			this.showSearchDR('');
			this.productCheckIcon = '';
			this.rejectedReasonList = [];
			this.holdReasonList = [];
			this.rejectReason = [];
			this.holdReason = [];
			this.productUploadUrl=""
			this.StoreimageUrls=[],
			this.currentimageno=0,
			this.productData = false;
			this.IDerrors = '';
			this.isProductNotInPO = false;
			this.outsideproduct = false;
		},

		loadProductImageError(imageSrc) {
			var srcLink = "static/img/defaultImg.png"
			var splitLink = imageSrc.split("id=")
			if (splitLink.length > 0) {
				if (splitLink[1]) {
					var srcLink = "https://drive.google.com/uc?export=view&id=" + splitLink[1]
				}
			}
			this.addGRC.productImage = srcLink
		},

		openpodetailsmodel() {
			this.podetailsmodal = true;
			this.getpodetils();
		},

		getpodetils() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				'pono': this.addGRC.pickPoNo,
				'clientid': this.clientid,
			});
			this.isLoading = true;
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getPoAllDetails',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.isLoading = false;
					this.podata = result.data.podata[0]
					this.poloopdata = result.data.podata;
					this.clientdata = result.data.clientdata;
					this.supplierdata = result.data.supplierdata[0];
				}, error => {
					this.isLoading = false;
					console.error(error);
				})
		},

		getScore(val) {
			return parseFloat(val).toFixed(2);
		},
		dateFormatFRT2(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD');
		},
		async Mfgdatefunction() {
			await this.checkexpirycutoff(this.addGRC.expdate)
			this.calculateMfgDate()
		},
		async Expdatefunction() {
			await this.calculateExpDate()
			this.checkexpirycutoff(this.addGRC.expdate)
		},
		calculateMfgDate() {

			var expairyDate = null;
			var mgGdate = null;
			this.expairyDate = moment(this.addGRC.expdate).format('YYYY-MM-DD')
			var shelfLife = this.addGRC.shelfLife;
			if (shelfLife) {
				var shelfLifes = shelfLife.split(' ');
				if (shelfLifes[0] != '' && shelfLifes[1] != '' && this.addGRC.expdate != null) {
					var shelfLifeNo = shelfLifes[0].trim();
					var shelfLifeCel = shelfLifes[1].trim();
					var expDate = new Date(this.expairyDate);
					var expYear = expDate.getFullYear();
					var expMonth = expDate.getMonth();
					var expDay = expDate.getDate();
					switch (shelfLifeCel) {
						case 'Year':
							var fullMFGDate = new Date(expYear - parseInt(shelfLifeNo), expMonth, expDay);

							break;

						case 'Month':
							var fullMFGDate = new Date(expYear, expMonth - parseInt(shelfLifeNo), expDay);

							break;

						case 'Day':
							var fullMFGDate = new Date(expYear, expMonth, expDay - parseInt(shelfLifeNo));

							break;
						case 'year':
							var fullMFGDate = new Date(expYear - parseInt(shelfLifeNo), expMonth, expDay);

							break;

						case 'month':
							var fullMFGDate = new Date(expYear, expMonth - parseInt(shelfLifeNo), expDay);

							break;

						case 'day':
							var fullMFGDate = new Date(expYear, expMonth, expDay - parseInt(shelfLifeNo));

							break;
					}
					if (fullMFGDate) {
						// var mgGdate = fullMFGDate.getFullYear() + "-" + (fullMFGDate.getUTCMonth() + 1) + "-" + fullMFGDate.getDate();
						var mgGdate = fullMFGDate.getFullYear() + "-" + (fullMFGDate.getMonth() + 1) + "-" + fullMFGDate.getDate();

					} else {
						var mgGdate = this.expairyDate;


					}
				}
			}
			this.addGRC.mfgdate = mgGdate
		},
		uomSelected() {
			if (this.addGRC.mfgdate != null || this.addGRC.mfgdate != '') {
				if (this.addGRC.shelflifeduration != null && this.addGRC.shelflifeuom != null) {
					this.addGRC.shelfLife = this.addGRC.shelflifeduration + " " + this.addGRC.shelflifeuom;
				}
				this.calculateExpDate();
			}
		},
		calculateExpDate() {
			var manufacturingdate = null;
			var expirydate = null;
			this.manufacturingdate = moment(this.addGRC.mfgdate).format('YYYY-MM-DD')
			var shelfLife = this.addGRC.shelfLife;
			if (shelfLife) {
				var shelfLifes = shelfLife.split(' ');
				if (shelfLifes[0] != '' && shelfLifes[1] != '' && this.addGRC.mfgdate != null) {
					var shelfLifeNo = shelfLifes[0].trim();
					var shelfLifeCel = shelfLifes[1].trim();
					var mfgDate = new Date(this.manufacturingdate);
					var mfgYear = mfgDate.getFullYear();
					var mfgMonth = mfgDate.getMonth();
					var mfgDay = mfgDate.getDate();
					switch (shelfLifeCel) {
						case 'Year':
							var fullExpDate = new Date(mfgYear + parseInt(shelfLifeNo), mfgMonth, mfgDay);

							break;

						case 'Month':
							var fullExpDate = new Date(mfgYear, mfgMonth + parseInt(shelfLifeNo), mfgDay);

							break;

						case 'Day':

							var fullExpDate = new Date(mfgYear, mfgMonth, mfgDay + parseInt(shelfLifeNo));

							break;
						case 'year':
							var fullExpDate = new Date(mfgYear + parseInt(shelfLifeNo), mfgMonth, mfgDay);

							break;

						case 'month':
							var fullExpDate = new Date(mfgYear, mfgMonth + parseInt(shelfLifeNo), mfgDay);

							break;

						case 'day':
							var fullExpDate = new Date(mfgYear, mfgMonth, mfgDay + parseInt(shelfLifeNo));

							break;
						case 'y':
							var fullExpDate = new Date(mfgYear + parseInt(shelfLifeNo), mfgMonth, mfgDay);

							break;

						case 'm':
							var fullExpDate = new Date(mfgYear, mfgMonth + parseInt(shelfLifeNo), mfgDay);

							break;

						case 'd':
							var fullExpDate = new Date(mfgYear, mfgMonth, mfgDay + parseInt(shelfLifeNo));

							break;
						case 'Y':
							var fullExpDate = new Date(mfgYear + parseInt(shelfLifeNo), mfgMonth, mfgDay);

							break;

						case 'M':
							var fullExpDate = new Date(mfgYear, mfgMonth + parseInt(shelfLifeNo), mfgDay);

							break;

						case 'D':
							var fullExpDate = new Date(mfgYear, mfgMonth, mfgDay + parseInt(shelfLifeNo));

							break;
					}
					if (fullExpDate) {
						var expirydate = fullExpDate.getFullYear() + "-" + (fullExpDate.getMonth() + 1) + "-" + fullExpDate.getDate();

					} else {
						var expirydate = this.manufacturingdate;
					}
				}
			}
			this.addGRC.expdate = expirydate
		},
		print() {
			const d = new Printd();
			var buffer = '';
			var cssText = `
        body{
        -webkit-print-color-adjust:exact;
        }
        table {
           border-collapse: collapse;
           margin-left:0px !important;
        }

        table, td, th {
         border-style: solid;
        border-width: 1px;

        margin-bottom: 10px;
        border-color: rgba(0,0,255,0.25);
           padding:5px;
        }
        pre {
        color: #c7254e;
        }
        .text-right{
        text-align:right;
        }

        .clientdetails{
        margin-top:-40px;
        font-size:12px;
        }
        @media print {
        .text-primary th{
        background-color:rgb(226, 216, 216) !important;
        color:black !important;
        font-size:20px !important;
        }
        thead
                    {
                        display:  table-header-group;
                    }

        }
        `
			d.print(document.getElementById('printPoContent'), cssText);
		},

		getElementByIdFn(elmId, val) {
			if (document.getElementById(elmId))
				document.getElementById(elmId).value = val;
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/GRC1/grc.component.js